import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accents'
})
export class UtilsAccentsPipe implements PipeTransform {
  transform(value: any): any {
    if (!value || value === null || value === 'a--') {
      return;
    }

    if (typeof value === 'object') {
      return;
    }
    const accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    const accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
    const str = value.split('');
    const strLen = str.length;
    let i, x;
    for (i = 0; i < strLen; i++) {
      if ((x = accents.indexOf(str[i])) !== -1) {
        str[i] = accentsOut[x];
      }
    }
    return str.join('');
  }
}
